import { ENGLISH_ABBREV, SPANISH_ABBREV, LanguageCode } from "@bto/shared";

export const I18NEXT_LANGUAGE_LOCAL_STORAGE_KEY = "i18nextLng";
export const LANGUAGE_QUERY_PARAM = "lang";

const SUPPORTED_LANGUAGES: readonly LanguageCode[] = [
  ENGLISH_ABBREV,
  SPANISH_ABBREV,
];

export const normalizeLanguage = (
  language: string | undefined,
): LanguageCode =>
  language?.split("-")[0] === SPANISH_ABBREV ? SPANISH_ABBREV : ENGLISH_ABBREV;

export const getLanguageFromQueryParam = (
  search: string,
): LanguageCode | null => {
  const languageParam = new URLSearchParams(search).get(LANGUAGE_QUERY_PARAM);
  if (languageParam === null) {
    return null;
  }
  const language = languageParam.split("-")[0] as LanguageCode;
  return SUPPORTED_LANGUAGES.includes(language) ? language : null;
};

export const getStoredLanguagePreference = (): string | null =>
  localStorage.getItem(I18NEXT_LANGUAGE_LOCAL_STORAGE_KEY);

export const persistLanguagePreference = (language: LanguageCode): void => {
  localStorage.setItem(I18NEXT_LANGUAGE_LOCAL_STORAGE_KEY, language);
};

/**
 * Persist a language requested via the URL query parameter, overriding any
 * stored preference. Persistence is intentionally not feature-flag gated: the
 * preference is saved even while the Spanish toggle flag is off so it takes
 * effect as soon as the flag turns on, but the displayed language stays
 * gated by the flag (see AppContainer's force-English logic).
 */
export const persistLanguageFromQueryParam = (
  search: string = window.location.search,
): void => {
  const language = getLanguageFromQueryParam(search);
  if (language !== null) {
    persistLanguagePreference(language);
  }
};
